export default __webpack_public_path__ + "static/LP2-ef0335c9200820b2fec2f7e0f982cd1c.png";